import React from 'react';
import { motion } from 'framer-motion';
import { Signature } from './graphics/Graphics';
export function DoctorClose() {
  return <section className="bg-cream py-16 md:py-20 px-5" data-id="element-58">
      <div className="max-w-[780px] mx-auto" data-id="element-59">
        <div className="flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-8 mb-8" data-id="element-60">
          <motion.img initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80" alt="Dr. Sarah Mitchell" className="w-[80px] h-[80px] rounded-full object-cover shrink-0 shadow-subtle" data-id="element-61" />
          <div className="text-center md:text-left pt-2" data-id="element-62">
            <div className="font-inter text-[12px] uppercase tracking-[0.1em] text-secondary mb-2" data-id="element-63">
              A Final Word
            </div>
            <h2 className="font-playfair text-[24px] md:text-[28px] text-ink font-semibold" data-id="element-64">
              From Dr. Sarah Mitchell
            </h2>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-inter text-[16px] text-ink leading-[1.75] space-y-5" data-id="element-65">
          <p data-id="element-66">
            In my twenty years of clinical practice, the most heartbreaking
            thing I saw wasn't the physical reality of incontinence. It was the
            way women quietly retreated from their own lives.
          </p>
          <p data-id="element-67">
            They stopped dancing. They stopped travelling. They stopped wearing
            clothes they loved. They accepted a smaller, safer, more restricted
            version of themselves because they believed they had no choice.
          </p>

          <div className="border-l-[4px] border-gold pl-5 my-8" data-id="element-68">
            <p className="font-playfair italic text-[20px] text-ink leading-relaxed" data-id="element-69">
              "The full version of you deserves a proper solution. This is the
              closest thing to one that I've seen available without a
              prescription."
            </p>
          </div>

          <p data-id="element-70">
            You do not have to settle for managing the mess. You do not have to
            accept that leaking is just 'part of getting older'. The science is
            there. The solution is there. You just need to try it.
          </p>

          <div className="mt-8 pt-6 border-t border-divider" data-id="element-71">
            <div className="font-inter font-semibold text-[14px] text-ink" data-id="element-72">
              — Dr. Sarah Mitchell, NHS Continence Specialist (Ret.)
            </div>
            <div className="font-inter text-[13px] text-secondary mt-1" data-id="element-73">
              BSc (Hons) Medicine, University of Manchester
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}